import { Link } from "react-router-dom";
import { ChevronRight, Code, Palette, Settings } from "lucide-react";

export const ServicesOverview = () => {
  const services = [
    {
      title: "Programming & Web Development",
      description:
        "Full-stack development, mobile applications, and technical solutions delivered by experienced developers across East Africa.",
      features: [
        "Custom Web Applications",
        "Mobile App Development",
        "API Integration",
        "Database Design",
        "Technical Consulting",
      ],
      icon: Code,
      gradient: "from-brand-primary to-brand-tertiary",
      bgPattern: "bg-gradient-to-br from-brand-secondary to-brand-secondary",
    },
    {
      title: "Digital Marketing & Graphics",
      description:
        "Comprehensive digital marketing strategies, content creation, and visual design services powered by creative professionals.",
      features: [
        "Social Media Strategy",
        "Content Creation",
        "Brand Design",
        "SEO Optimization",
        "Photography Services",
      ],
      icon: Palette,
      gradient: "from-brand-primary to-brand-tertiary",
      bgPattern: "bg-gradient-to-br from-brand-secondary to-brand-secondary",
    },
    {
      title: "Business Process Outsourcing",
      description:
        "Reliable BPO services including data management, administrative support, and specialized business operations.",
      features: [
        "Data Management",
        "Administrative Support",
        "Quality Assurance",
        "Documentation Services",
        "Process Optimization",
      ],
      icon: Settings,
      gradient: "from-brand-primary to-brand-tertiary",
      bgPattern: "bg-gradient-to-br from-brand-secondary to-brand-secondary",
    },
  ];

  return (
    <section id="services" className="py-20 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-brand-primary">
            Case Studies
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our real-world impact across programming, web development,
            digital marketing, graphic design, and BPO—demonstrating how we
            deliver international standards through African excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-5 rounded-3xl transition-opacity duration-500`}
              ></div>

              <div className="relative z-10">
                <div
                  className={`w-16 h-16 rounded-2xl bg-gradient-to-r ${service.gradient} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}
                >
                  <service.icon className="text-white" size={28} />
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      className="flex items-center text-sm text-gray-600"
                    >
                      <div
                        className={`w-2 h-2 rounded-full bg-gradient-to-r ${service.gradient} mr-3 flex-shrink-0`}
                      ></div>
                      {feature}
                    </li>
                  ))}
                </ul>

                <Link
                  to="/services"
                  className="group/btn flex items-center text-gray-600 hover:text-brand-primary font-semibold transition-all duration-300"
                >
                  Explore Service
                  <ChevronRight
                    size={16}
                    className="ml-2 group-hover/btn:translate-x-1 transition-transform"
                  />
                </Link>

                <div
                  className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${service.gradient} rounded-b-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
                ></div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-brand-primary to-brand-tertiary text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            View All Services
            <ChevronRight size={20} className="ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};
